import {
  animate,
  query,
  sequence,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const layoutAnimationEnterAppAnimation = trigger(
  'layoutAnimationEnterAppAnimation',
  [
    transition('* => loginSuccessMobile', [
      sequence([
        query('.my-layout-inner-body', animate('0.2s', style({ opacity: 0 }))),
        query(
          '.my-header',
          animate('0.4s 0.4s', style({ position: 'absolute', top: '-400px' })),
        ),
      ]),
    ]),
    transition('* => loginSuccessDesktop', [
      sequence([
        query('.my-layout-inner-body', animate('0.2s', style({ opacity: 0 }))),
        query(
          '.my-header',
          animate(
            '0.8s 0.4s ease-out',
            style({ position: 'absolute', right: '-2000px' }),
          ),
        ),
      ]),
    ]),
  ],
);
